/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_CrumbInputs */

const en_landing_crumb = /** @type {(inputs: Landing_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Home`)
};

const pl_landing_crumb = /** @type {(inputs: Landing_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strona główna`)
};

/**
* | output |
* | --- |
* | "Home" |
*
* @param {Landing_CrumbInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const landing_crumb = /** @type {((inputs?: Landing_CrumbInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_CrumbInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_landing_crumb(inputs)
	return en_landing_crumb(inputs)
});